import { observer } from 'mobx-react-lite'
import { Alert, Button } from 'shared/ui'
import { INDEXATION_RETRY } from 'pages/settings/pages/knowledgeBase/lib/constants'
import { KnowledgeBaseRoutes } from 'pages/settings/pages/knowledgeBase'
import styles from './styles.module.scss'

type KnowledgeBaseAlertProps = {
  isEmpty: boolean
  error?: string | null
  isKnowledgeBaseDocumentsEmpty: boolean
  isBaseErrorMessage?: boolean
}

export const KnowledgeBaseAlert = observer(
  ({
    isEmpty,
    error,
    isKnowledgeBaseDocumentsEmpty,
    isBaseErrorMessage,
  }: KnowledgeBaseAlertProps) => {
    if (!isEmpty && !error && !isKnowledgeBaseDocumentsEmpty) return null
    const isServerEmptyBaseMessage = isBaseErrorMessage && isEmpty

    if (isKnowledgeBaseDocumentsEmpty) {
      return (
        <Alert
          item={{
            type: 'alert',
            desc: (
              <div className={styles.alert}>
                <span>{INDEXATION_RETRY}</span>
                <Button
                  text='Try again'
                  typeBtn='outlined'
                  size='small'
                  contained='secondary'
                  onClick={() => window.open(`/${KnowledgeBaseRoutes.root}`, '_blank')}
                  className={styles.alertButton}
                />
              </div>
            ),
          }}
        />
      )
    }

    const alertType = error || isServerEmptyBaseMessage ? 'alert' : 'warning'
    const alertDescription = isEmpty ? (
      <div className={styles.alert}>
        <span>Your knowledge base is empty, add documents to get started</span>
        <Button
          text='Add documents'
          typeBtn='outlined'
          size='small'
          contained='secondary'
          onClick={() => window.open(`/${KnowledgeBaseRoutes.root}`, '_blank')}
          className={styles.alertButton}
        />
      </div>
    ) : (
      error
    )

    return <Alert item={{ type: alertType, desc: alertDescription }} />
  }
)
